// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { MessageProcessorBase } from './MessageProcessorBase';
import { DirectNewsMessage } from '@shared/utils/DirectMessages/DirectNewsMessage';
import { NewsGroup } from '../Groups/GroupsImport';
export class NewsMessageProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        const message = new DirectNewsMessage();
        const newsGroups = fieldSet.GetGroups(FieldsFactory.NEWS_GROUP);
        if (newsGroups) {
            for (let i = 0; i < newsGroups.length; i++) {
                const newsGroup = new NewsGroup(newsGroups[i]);
                message.NewsGroupsArr.push(newsGroup);
            }
        }
        message.RequestID = fieldSet.GetValue(FieldsFactory.FIELD_REQUEST_ID);
        return [message];
    }
}
